<template>
<div class="bread-nav">
  <span class="bread-now">当前位置：</span>
  <ul class="bread-list">
    <li>{{nowTab}}</li>
  </ul>
</div>
</template>

<script>
export default {
  name: 'BreadNav',
  computed: {
    tabIndex() {
      return this.$store.state.tabIndex;
    },
    nowTab() {
      return ['', '公司首页', '企业文化', '历史项目', '新闻公告', '联系我们', '专家抽取'][this.tabIndex];
    },
  },
};
</script>

<style scoped>

</style>
